var _rect, _line, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiniCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 3,
    width: 21,
    height: 20,
    rx: 4,
    stroke: "#74B743",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.04547,
    y1: 10,
    x2: 21.9546,
    y2: 10,
    stroke: "#74B743",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 6.22729,
    y1: -4.37114e-8,
    x2: 6.2273,
    y2: 7,
    stroke: "#74B743",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 11.4545,
    y1: -4.18109e-8,
    x2: 11.4545,
    y2: 7,
    stroke: "#74B743",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 16.6818,
    y1: -4.18109e-8,
    x2: 16.6818,
    y2: 7,
    stroke: "#74B743",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniCalender);
export default __webpack_public_path__ + "static/media/MiniCalender.8e34b2d436e06038e651793fdcbff5d1.svg";
export { ForwardRef as ReactComponent };